import { render, staticRenderFns } from "./dashboardReportsAccountsummary.vue?vue&type=template&id=888ebfa8"
import script from "./dashboardReportsAccountsummary.vue?vue&type=script&lang=js"
export * from "./dashboardReportsAccountsummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports